import {
  Building2,
  Calendar,
  Contact,
  DollarSignIcon,
  FileText,
  Globe,
  MessageCircle,
  ShoppingBag,
  Tv2Icon,
} from 'lucide-react';

import type { RouteListItem } from '@/types';

import AgreementsIcon from '../images/icons/agreements.svg?react';
import ApiIntegration from '../images/icons/api-integration.svg?react';

export const companiesSubNav: RouteListItem[] = [
  {
    path: '/companies/$id',
    icon: Building2,
    name: 'Profile',
    auditKey: 'client/profile',
  },
  {
    path: '/companies/$id/contacts',
    icon: Contact,
    name: 'Contacts',
    auditKey: 'client/contacts',
  },
  {
    path: '/companies/$id/domains',
    icon: Globe,
    name: 'Domains',
    auditKey: 'client/domains',
  },
  {
    path: '/companies/$id/api-integration',
    icon: ApiIntegration,
    name: 'API Integrations',
    auditKey: 'client/api-integration',
  },
  {
    path: '/companies/$id/agreements',
    icon: AgreementsIcon,
    name: 'Agreements',
    auditKey: 'client/agreements',
  },
  {
    path: '/companies/$id/marketing-campaigns',
    icon: Tv2Icon,
    name: 'Marketing Campaigns',
    auditKey: 'client/marketing-campaigns',
  },
  {
    path: '/companies/$id/support',
    icon: MessageCircle,
    name: 'Support',
    auditKey: 'client/support',
    isDisabled: false,
    isDoubleNested: true,
  },
  {
    path: '/companies/$id/notes',
    icon: FileText,
    name: 'Notes',
    auditKey: 'client/notes',
    isDisabled: false,
  },
  {
    path: '/companies/$id/financials',
    icon: DollarSignIcon,
    name: 'Financials',
    auditKey: 'client/financials',
    // Tab is now enabled - will be controlled by hasActiveAgreement logic
  },
  {
    path: '/companies/$id/subscriptions',
    icon: Calendar,
    name: 'Subscriptions',
    auditKey: 'client/subscriptions',
    isDisabled: true,
  },
  {
    path: '/companies/$id/invoice-history',
    icon: ShoppingBag,
    name: 'Invoice History',
    auditKey: 'client/invoice-history',
    isDisabled: true,
  },
];
